export default __webpack_public_path__ + "static/media/Group82.757cf267.svg";